export default __webpack_public_path__ + "static/media/my_journey_part1_9.3cec4cb7.png";